import { showErrorNotification, showSuccessNotification } from '../../global/notifications';
import { loadCommissionPlanBuilder } from './commission-plan-builder';
import { triggerPlanUpdated } from './event-handlers';
import { sendAfToken } from '../../global/all';

let $addButton = null;

let _selectedPlan = null;
let _selectedPlanAssignmentId = null;
let _selectedEmployee = null;

let _k_planSelect = null;
let _k_effectiveDatePicker = null;
let _k_completionDatePicker = null;

const _minDate = new Date(1901, 0, 1);
const _maxDate = new Date(new Date().getFullYear() + 100, 11, 31);

export function loadPlanAssignmentPane(selectedEmployee, selectedPlanAssignmentId) {
    $('#CommissionBuilderPane').empty();

    _selectedEmployee = selectedEmployee;
    _selectedPlanAssignmentId = selectedPlanAssignmentId;
    const data = {
        employeeNumber: selectedEmployee.EmployeeNumber,
        planAssignmentId: selectedPlanAssignmentId
    };

    return new Promise((resolve, reject) => {
        $('#PlanAssignment').load('/Commissions/CommissionPlanAssignment/GetPlanAssignmentPane', data, (response, status) => {
            if (status === 'error') {
                reject(new Error('Failed to load plan information'));
                return;
            }

            initializePlanAssignmentPane();
            resolve();
        });
    });
}

function initializePlanAssignmentPane() {
    $(document).trigger('on:PageUpdate');
    setUpDatePickers();
    setupAddPlanButton();
    setupDirectCalcButton();
    initializePlanConfigurationSelect().then(() => {
        const planTypeId = $('#plan-id').val();
        toggleAssignmentPaneReadonly(planTypeId === '');

        checkValidation();

        if (planTypeId !== '') {
            $('#add-plan-assignment').hide();
            $('#loading-add-plan-button').hide();
            loadCommissionPlanBuilder(_selectedEmployee, _selectedPlan, _selectedPlanAssignmentId);
            checkDirectCalcAvailability(_selectedPlanAssignmentId);
        }
    });
}

function initializePlanConfigurationSelect() {
    return new Promise(resolve => {
        _selectedPlan = null;

        const dropdownDataSource = new kendo.data.DataSource({
            serverFiltering: false,
            transport: {
                read(options) {
                    $.ajax({
                        url: '/Commissions/CommissionPlanAssignment/GetAvailablePlanList',
                        type: 'post',
                        data: JSON.stringify(_selectedEmployee),
                        contentType: 'application/json',
                        success(result) {
                            options.success(result);
                        },
                        error(result) {
                            options.error(result);
                        },
                    });
                },
            },
        });

        const $planSelect = $('#plan-configuration-select');
        _k_planSelect = $planSelect
            .kendoDropDownList({
                optionLabel: ' ',
                dataTextField: 'Name',
                filter: 'contains',
                dataSource: dropdownDataSource,
                width: '100%',
                select: onPlanSelected,
                dataBound: onDataBound,
            })
            .data('kendoDropDownList');

        function onPlanSelected(event) {
            _selectedPlan = event.dataItem;

            checkValidation();
        }

        function onDataBound() {
            if ($planSelect.data('value')) {
                let savedValue = _k_planSelect.dataSource.data().find(plan => plan.Id === $planSelect.data('value'));
                _k_planSelect.value(savedValue);
                _selectedPlan = savedValue;
            }

            resolve();
        }
    });
}

function setUpDatePickers() {
    const $planEffectiveDatePicker = $('#plan-effective-date');
    _k_effectiveDatePicker = $planEffectiveDatePicker.data('kendoDatePicker');
    const $planCompletionDatePicker = $('#plan-completion-date');
    _k_completionDatePicker = $planCompletionDatePicker.data('kendoDatePicker');

    if (_k_effectiveDatePicker) {
        _k_effectiveDatePicker.setOptions({
            change: function () {
                let value = this.value();
                if (!value) {
                    value = _minDate;
                }

                dateChangeEvent();
            }
        });

        if ($planEffectiveDatePicker.data('value')) {
            _k_effectiveDatePicker.value($planEffectiveDatePicker.data('value'));
        }
    }

    if (_k_completionDatePicker) {
        _k_completionDatePicker.setOptions({
            change: function () {
                let value = this.value();
                if (!value) {
                    value = _maxDate;
                }

                dateChangeEvent();
            }
        });

        if ($planCompletionDatePicker.data('value')) {
            _k_completionDatePicker.value($planCompletionDatePicker.data('value'));
        }
    }

}

function setupAddPlanButton() {
    $addButton = $('#add-plan-assignment');

    $addButton.click(function (event) {
        toggleAddPlanButton(false);
        toggleAssignmentPaneReadonly(false);
        addPlanEvent(event)
            .then(function (result) {
                triggerPlanUpdated();
                showSuccessNotification(result);
                $('#add-plan-assignment').hide();
                $('#loading-add-plan-button').hide();
            })
            .then(() => {
                loadCommissionPlanBuilder(_selectedEmployee, _selectedPlan, _selectedPlanAssignmentId);
            })
            .catch((error) => {
                showErrorNotification(error);
                toggleAddPlanButton(true);
                toggleAssignmentPaneReadonly(true);
            })
            .finally();
    });
}

function dateChangeEvent() {
    _k_planSelect.dataSource.filter({
        logic: 'and',
        filters: [
            {
                field: 'AssignableAsOf',
                operator: function(item) {
                    const assignableAsOf = new Date(item);
                    const effectiveDate = _k_effectiveDatePicker.value();
                    const effectiveDateOnly = dateOnly(effectiveDate);

                    if (!effectiveDateOnly) {
                        return true;
                    }

                    return assignableAsOf <= effectiveDateOnly;
                },
            },
            {
                field: 'ExpirationDate',
                operator: function(item) {
                    const expirationDate = new Date(item);
                    const completionDate = _k_completionDatePicker.value();
                    const completionDateOnly = dateOnly(completionDate);

                    if (!completionDateOnly) {
                        return true;
                    }

                    return expirationDate >= completionDateOnly;
                },
            },
        ],
    });

    _selectedPlan = null;
    _k_planSelect.value('');

    checkValidation();
}

function checkValidation() {
    const validationResult = validate();

    $('#plan-assignment-invalid').text(validationResult);

    $addButton.prop('disabled', !!validationResult);
}

function overlaps(effectiveDate, completionDate, otherPlanAssignment) {
    return dateOnly(completionDate) >= new Date(otherPlanAssignment.EffectiveDate) &&
        dateOnly(effectiveDate) <= new Date(otherPlanAssignment.EndDate);
}

function dateOnly(dateValue) {
    if (!dateValue) {
        return undefined;
    }

    return new Date(Date.UTC(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate()));
}

function validate() {
    if (!_k_effectiveDatePicker || !_k_completionDatePicker) {
        return 'datepickers not initialized';
    }

    const effectiveDate = _k_effectiveDatePicker.value();
    const completionDate = _k_completionDatePicker.value();

    if (!completionDate || !effectiveDate) {
        return 'Plan effective date and completion date are required';
    }

    if (completionDate < effectiveDate) {
        return 'Completion date must be after the effective date';
    }

    const currentPlans = $('#plan-assignment-grid')
        .data('kendoGrid')
        .dataSource.data();

    if (currentPlans.some(x => overlaps(effectiveDate, completionDate, x))) {
        return 'The selected dates overlap with an existing plan. Please adjust the dates or terminate the existing plan.';
    }

    const filteredItemsCount = _k_planSelect.dataSource.view().length;

    if (filteredItemsCount === 0) {
        return 'No plans are eligible within the timeframe selected';
    }

    if (!_selectedEmployee || !_selectedPlan) {
        return 'Select a plan';
    }

    const effectiveDateOnly = dateOnly(effectiveDate);
    const completionDateOnly = dateOnly(completionDate);
    const assignableAsOf = new Date(_selectedPlan.AssignableAsOf);
    const expirationDate = new Date(_selectedPlan.ExpirationDate);

    if (assignableAsOf > effectiveDateOnly || expirationDate < completionDateOnly) {
        return 'The plan assignment is outside of plan configuration allowable dates.';
    }

    return null;
}

function addPlanEvent(event) {
    return new Promise((resolve, reject) => {
        const validationResult = validate();

        if (validationResult) {
            reject(new Error(validationResult));
        }

        const effectiveDate = _k_effectiveDatePicker.value();
        const completionDate = _k_completionDatePicker.value();

        const data = {
            PlanConfigurationId: _selectedPlan.Id,
            EmployeeNumber: _selectedEmployee.EmployeeNumber,
            EmployeeName  : _selectedEmployee.EmployeeName,
            EffectiveDate : kendo.toString(effectiveDate, 'MM/dd/yyyy'),
            CompletionDate: kendo.toString(completionDate, 'MM/dd/yyyy')
        };

        $.post('/Commissions/CommissionPlanAssignment/CreatePlanAssignment', data, (newId) => {
            if (newId) {
                _selectedPlanAssignmentId = newId;
                resolve('Plan created successfully');
            } else {
                reject(new Error('Failed to create plan'));
            }
        }).fail((response) =>  reject(new Error(response.responseText)));
    });
}

function toggleAddPlanButton(isEnabled) {
    $('#add-plan-assignment').attr('disabled', !isEnabled);
    const $addPlanLoadingSpinner = $('#loading-add-plan-button');
    if (isEnabled) {
        $addPlanLoadingSpinner.hide();
    } else {
        $addPlanLoadingSpinner.show();
    }
}

function setupDirectCalcButton() {
    $('#plan-direct-calc-wrapper').find('#plan-direct-calc-btn').on('click', function () {
        const $btn = $(this);
        $btn.prop('disabled', true);
        $.ajax({
            type: 'POST',
            url: `/Commissions/CommissionPlanAssignment/TriggerDirectCalculation?planAssignmentId=${_selectedPlanAssignmentId}`,
            data: sendAfToken({}),
            success: function () {
                showSuccessNotification('Calculation triggered. You will receive an email when results are ready.');
            },
            error: function (xhr) {
                showErrorNotification(xhr.responseJSON?.message ?? xhr.responseText ?? 'Calculation failed. Please try again.');
                // Only re-enable for transient failures (5xx / network); keep disabled for business rule rejections (4xx)
                if (!xhr.status || xhr.status >= 500) {
                    $btn.prop('disabled', false);
                }
            }
        });
    });
}

function setDirectCalcTooltip(reason) {
    const $wrapper = $('#plan-direct-calc-wrapper');
    const existing = $wrapper.data('kendoTooltip');
    if (existing) {
        existing.options.content = reason;
    } else {
        $wrapper.kendoTooltip({
            position: 'top',
            showOn: 'mouseenter',
            autoHide: true,
            width: 260,
            content: reason,
            show: function () {
                this.popup.element.css({
                    background: '#fff',
                    border: '2px solid #6698df',
                    borderRadius: '4px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    color: '#333',
                    padding: '6px 10px'
                });
            }
        });
    }
}

function checkDirectCalcAvailability(planAssignmentId) {
    const $btn = $('#plan-direct-calc-btn');
    if ($btn.length === 0) {
        return;
    }
    $.ajax({
        type: 'GET',
        url: `/Commissions/CommissionPlanAssignment/GetDirectCalculationStatus?planAssignmentId=${planAssignmentId}`,
        success: function (data) {
            if (data.available) {
                $btn.prop('disabled', false);
                const tooltip = $('#plan-direct-calc-wrapper').data('kendoTooltip');
                if (tooltip) tooltip.destroy();
            } else {
                $btn.prop('disabled', true);
                setDirectCalcTooltip(data.reason ?? '');
            }
        },
        error: function () {
            $btn.prop('disabled', true);
            setDirectCalcTooltip('Unable to check status, please try again.');
        }
    });
}

function toggleAssignmentPaneReadonly(isEnabled) {
    if (_k_completionDatePicker && _k_effectiveDatePicker) {
        _k_effectiveDatePicker.enable(isEnabled);
        _k_completionDatePicker.enable(isEnabled);
    }

    if (_k_planSelect) {
        _k_planSelect.enable(isEnabled);
    }
}
